import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { environment } from '@env/environment';
import { Alert, AlertsService } from '@gravity-angular/base';
import { ColorType } from '@gravity-angular/models';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  alert: Alert;

  constructor(
    private readonly alertsService: AlertsService,
    private readonly zone: NgZone
  ) {}

  handleError(error: any): void {
    // Errors are getting wrapped by zone for some reason.
    const httpError = error.rejection || error;

    this.alert = {
      title: 'Error',
      message: error.message || 'An error has occurred.',
      type: ColorType.danger,
      dismissable: true
    };
    this.alertsService.addAlert(this.alert);
    if (httpError.status === 401 || httpError.status === 403) {
      // User needs authentication or authorization, send to log in screen to handle proper redirect
      this.redirect();
    } else {
      console.error('Message:', error.message);
      console.error('Error:', error); // Added for additional clarity in production
    }
  }

  redirect(): void {
    if (environment.production) {
      this.zone.run(() => {
        // this.authRedirectService.redirect();
      });
    }
  }
}
